<template>
  <div>
    <NavBar />
    <div class="control-panel">
      <router-link
        :to="prevDash || '/home'"
        class="control-panel__goBack"
      >
        <icon name="arrow-left" style="vertical-align: -2px;" />
        <span>Go to last Dashboard</span>
      </router-link>
      <b-tabs
        v-model="tabIndex"
        class="control-panel__tabs"
      >
        <b-tab
          v-for="(tab, idx) in tabs"
          :key="tab.key"
        >
          <template
            slot="title"
          >
            <span
              class="control-panel__tabTrigger"
            >
              {{ tab.title }}
            </span>
          </template>
          <div class="control-panel__tabContent">
            <UserAccess
              v-if="tab.key === 'uAccess'"
            />
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
// components
import NavBar from '@/components/NavBar'
import UserAccess from './components/UserAccess'

export default {
  components: {
    NavBar,
    UserAccess
  },
  data () {
    return {
      tabIndex: 0,
      tabs: [
        {
          title: 'User Access',
          key: 'uAccess'
        }
      ]
    }
  },
  computed: {
    prevDash () {
      const lastDash = localStorage.getItem('lastDash')

      return lastDash ? `/dashboard/${lastDash}` : null
    }
  },
  beforeDestroy() {
    this.$releaseEvents()
  }
}
</script>

<style lang="scss">
.control-panel {
  padding: 10px;
  height: calc(100vh - 38px);
  overflow: auto;
  &__goBack {
    display: inline-block;
    margin-bottom: 10px;
  }
}
</style>
